import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import MobileSideMenu from '../customer_pages/_megamenu/mobile-side-menu';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('mobile-side-menu');

  const props = JSON.parse(root.dataset.props);

  hydrateRoot(root, <MobileSideMenu {...props} />);
});
